import NextLink from 'next/link'
import Image from 'next/image'
import {
    Box,
    Flex,
    Text,
    IconButton,
    Spinner,
    Button,
    Stack,
    Collapse,
    Icon,
    Link,
    LinkOverlay,
    Menu,
    MenuButton,
    MenuList,
    MenuItem,
    MenuDivider,
    Popover,
    useColorModeValue,
    useDisclosure,
    useColorMode,
    HStack
  
  } from '@chakra-ui/react';
  import {
    HamburgerIcon,
    CloseIcon,
    ChevronDownIcon,
  } from '@chakra-ui/icons';
  import { FaMoon, FaSun, FaHeart, FaUserCircle } from "react-icons/fa";
  import { useRouter } from 'next/router';
  import { useEffect, useState } from 'react'
  import { GiDna2 } from "react-icons/gi";
  import { BiDna } from "react-icons/bi";
  import { useAuth, useClerk } from '@clerk/nextjs';

  export default function Navbar(props) {
    const router = useRouter();
    const { isOpen, onToggle } = useDisclosure();
    const text = useColorModeValue("dark", "light");
    const MenuBG = useColorModeValue("white", "darkGray.900");
    const borderColor = useColorModeValue("gray.200", "neutral.900")
    const inputText = useColorModeValue("black", "white")
    const { toggleColorMode: toggleMode } = useColorMode();
    const SwitchIcon = useColorModeValue(FaMoon, FaSun);
    const logoFill = useColorModeValue('black', 'white');
    const buttonColor = useColorModeValue('gray.900', 'gray.100');
    const buttonBG = useColorModeValue('gray.100', 'gray.700');
    const { isLoaded, userId, sessionId, getToken } = useAuth();
    const { signOut } = useClerk();
    
    const signout = () => {
      if (window.CRISP_TOKEN_ID != undefined) {
        delete window.CRISP_TOKEN_ID;
        window.$crisp.push(["do", "session:reset"]);
      }

      signOut()
      window.location.replace('/signin')
      // router.push('/signin')
    }

    const authLinks = (
      <>
        <Menu>
          <MenuButton
            as={IconButton}
            size="md"
            fontSize="lg"
            variant="ghost"
            icon={<FaUserCircle />}
            />
          <MenuList bg={MenuBG} borderColor={borderColor}>
          <NextLink href="/settings" passHref>
            <MenuItem sx={{'fontWeight': 'normal', 'lineHeight': 'normal', 'fontSize': '14'}}>Settings</MenuItem>
            </NextLink>
            <MenuDivider />
            <MenuItem sx={{'fontWeight': 'normal', 'lineHeight': 'normal', 'fontSize': '14'}} onClick={() => signout()}>Sign Out</MenuItem>
            {/* <MenuItem sx={{'fontWeight': 'normal', 'lineHeight': 'normal', 'fontSize': '14'}}>
              <Text }>Sign out</Text>
            </MenuItem> */}
          </MenuList>
        </Menu>
        </>
    );

  const guestLinks = (
    <>
    <Button
      as={'a'}
      fontSize={'sm'}
      fontWeight={600}
      variant={'link'}
      href={'/signin'}>
      Sign In
    </Button>
    <Button
    as={'a'}
      // display={{ md: 'inline-flex' }}
      fontSize={'sm'}
      fontWeight={600}
        bg={useColorModeValue('gray.900', 'gray.700')}
        color="white"
        border= "1px solid"
        borderColor={useColorModeValue('gray.900', 'gray.700')}
        _hover={{
          bg: 'none',
          border: '1px solid',
          borderColor:`${useColorModeValue('gray.900', 'gray.200')}`,
          color: `${useColorModeValue('gray.900', 'gray.200')}`,
        }}
        _active={{
            bg: 'none',
          // transform: "scale(0.98)",
          borderColor: `${useColorModeValue('black', 'gray.200')}`,
        }}
      href={'/signup'}
      // colorScheme="darkGray"
      // bgGradient="linear(to-r, purple.300, purple.500)"
      // _hover={{
      //   bgGradient: "linear(to-r, cyan.600, green.400)"
      // }}
      >
      Sign Up
    </Button>
    </>
  )
  
    return (
      <Box>
        <Flex
          bg={useColorModeValue('white', 'darkGray.900')}
          color={useColorModeValue('gray.600', 'white')}
          minH={'60px'}
          // maxW={'6xl'}
          py={{ base: 2 }}
          px={{ base: 4 }}
          borderBottom={0}
          borderStyle={'solid'}
          borderColor={useColorModeValue('gray.200', 'gray.900')}
          align={'center'}
          >
          <Flex
            flex={{ base: 1, md: 'auto' }}
            ml={{ base: -2 }}
            display={{ base: 'flex', md: 'none' }}
            >
            <IconButton
              onClick={onToggle}
              icon={
                isOpen ? <CloseIcon w={3} h={3} /> : <HamburgerIcon w={5} h={5} />
              }
              variant={'ghost'}
              aria-label={'Toggle Navigation'}
            />
          </Flex>
          
          <Flex flex={{ base: 1 }} justify={{ base: 'center', md: 'start' }} >
          <HStack spacing={100}>
          <NextLink href="/" passHref>
            <Link>
          <svg height="60" viewBox="0 0 1671 685" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M556.895 377.551C565.515 379.158 572.6 383.468 578.151 390.48C583.702 397.492 586.478 405.527 586.478 414.584C586.478 422.765 584.433 429.997 580.342 436.278C576.398 442.414 570.628 447.235 563.031 450.741C555.435 454.247 546.45 456 536.078 456H470.12V303.047H533.229C543.602 303.047 552.513 304.727 559.963 308.087C567.56 311.447 573.257 316.122 577.055 322.112C581 328.101 582.972 334.894 582.972 342.491C582.972 351.402 580.562 358.852 575.741 364.842C571.066 370.831 564.784 375.068 556.895 377.551ZM500.798 366.157H528.847C536.151 366.157 541.776 364.55 545.72 361.336C549.664 357.976 551.636 353.228 551.636 347.092C551.636 340.957 549.664 336.209 545.72 332.849C541.776 329.489 536.151 327.809 528.847 327.809H500.798V366.157ZM531.696 431.019C539.146 431.019 544.916 429.266 549.007 425.76C553.243 422.254 555.362 417.287 555.362 410.859C555.362 404.285 553.17 399.172 548.788 395.52C544.405 391.722 538.489 389.823 531.038 389.823H500.798V431.019H531.696ZM626.486 320.139C621.081 320.139 616.553 318.459 612.9 315.099C609.394 311.593 607.641 307.284 607.641 302.171C607.641 297.058 609.394 292.821 612.9 289.461C616.553 285.955 621.081 284.202 626.486 284.202C631.892 284.202 636.347 285.955 639.853 289.461C643.506 292.821 645.332 297.058 645.332 302.171C645.332 307.284 643.506 311.593 639.853 315.099C636.347 318.459 631.892 320.139 626.486 320.139ZM641.606 334.602V456H610.928V334.602H641.606ZM725.823 457.972C714.136 457.972 703.617 455.416 694.268 450.303C684.918 445.043 677.541 437.666 672.136 428.17C666.877 418.675 664.247 407.718 664.247 395.301C664.247 382.884 666.95 371.927 672.355 362.431C677.906 352.936 685.43 345.631 694.925 340.518C704.421 335.259 715.012 332.63 726.699 332.63C738.386 332.63 748.977 335.259 758.473 340.518C767.969 345.631 775.419 352.936 780.824 362.431C786.375 371.927 789.151 382.884 789.151 395.301C789.151 407.718 786.302 418.675 780.605 428.17C775.054 437.666 767.457 445.043 757.816 450.303C748.32 455.416 737.656 457.972 725.823 457.972ZM725.823 431.238C731.374 431.238 736.56 429.924 741.381 427.294C746.348 424.518 750.292 420.428 753.214 415.023C756.136 409.617 757.596 403.044 757.596 395.301C757.596 383.76 754.529 374.922 748.393 368.786C742.403 362.504 735.026 359.364 726.261 359.364C717.496 359.364 710.118 362.504 704.129 368.786C698.285 374.922 695.363 383.76 695.363 395.301C695.363 406.842 698.212 415.753 703.91 422.035C709.753 428.17 717.057 431.238 725.823 431.238ZM803.766 395.301C803.766 382.738 806.323 371.781 811.436 362.431C816.549 352.936 823.634 345.631 832.691 340.518C841.749 335.259 852.121 332.63 863.808 332.63C878.855 332.63 891.272 336.428 901.06 344.025C910.994 351.475 917.641 361.993 921.001 375.579H887.912C886.159 370.32 883.164 366.23 878.928 363.308C874.837 360.24 869.724 358.706 863.589 358.706C854.823 358.706 847.884 361.92 842.771 368.348C837.658 374.63 835.102 383.614 835.102 395.301C835.102 406.842 837.658 415.826 842.771 422.254C847.884 428.536 854.823 431.677 863.589 431.677C876.006 431.677 884.114 426.125 887.912 415.023H921.001C917.641 428.17 910.994 438.616 901.06 446.358C891.126 454.101 878.709 457.972 863.808 457.972C852.121 457.972 841.749 455.416 832.691 450.303C823.634 445.043 816.549 437.739 811.436 428.39C806.323 418.894 803.766 407.864 803.766 395.301ZM997.381 457.972C985.694 457.972 975.176 455.416 965.826 450.303C956.477 445.043 949.1 437.666 943.694 428.17C938.435 418.675 935.806 407.718 935.806 395.301C935.806 382.884 938.508 371.927 943.913 362.431C949.465 352.936 956.988 345.631 966.484 340.518C975.979 335.259 986.571 332.63 998.258 332.63C1009.94 332.63 1020.54 335.259 1030.03 340.518C1039.53 345.631 1046.98 352.936 1052.38 362.431C1057.93 371.927 1060.71 382.884 1060.71 395.301C1060.71 407.718 1057.86 418.675 1052.16 428.17C1046.61 437.666 1039.02 445.043 1029.37 450.303C1019.88 455.416 1009.21 457.972 997.381 457.972ZM997.381 431.238C1002.93 431.238 1008.12 429.924 1012.94 427.294C1017.91 424.518 1021.85 420.428 1024.77 415.023C1027.69 409.617 1029.16 403.044 1029.16 395.301C1029.16 383.76 1026.09 374.922 1019.95 368.786C1013.96 362.504 1006.58 359.364 997.819 359.364C989.054 359.364 981.677 362.504 975.687 368.786C969.844 374.922 966.922 383.76 966.922 395.301C966.922 406.842 969.771 415.753 975.468 422.035C981.312 428.17 988.616 431.238 997.381 431.238ZM1075.32 394.863C1075.32 382.591 1077.74 371.708 1082.56 362.212C1087.52 352.717 1094.24 345.412 1102.72 340.299C1111.19 335.186 1120.61 332.63 1130.98 332.63C1138.87 332.63 1146.4 334.383 1153.55 337.889C1160.71 341.249 1166.41 345.778 1170.65 351.475V293.844H1201.76V456H1170.65V438.031C1166.85 444.021 1161.52 448.842 1154.65 452.494C1147.78 456.146 1139.82 457.972 1130.76 457.972C1120.54 457.972 1111.19 455.343 1102.72 450.083C1094.24 444.824 1087.52 437.447 1082.56 427.951C1077.74 418.31 1075.32 407.28 1075.32 394.863ZM1170.87 395.301C1170.87 387.851 1169.4 381.496 1166.48 376.237C1163.56 370.831 1159.62 366.741 1154.65 363.965C1149.68 361.044 1144.35 359.583 1138.65 359.583C1132.96 359.583 1127.7 360.971 1122.88 363.746C1118.06 366.522 1114.11 370.612 1111.04 376.018C1108.12 381.277 1106.66 387.558 1106.66 394.863C1106.66 402.167 1108.12 408.595 1111.04 414.146C1114.11 419.551 1118.06 423.715 1122.88 426.637C1127.84 429.558 1133.1 431.019 1138.65 431.019C1144.35 431.019 1149.68 429.631 1154.65 426.856C1159.62 423.934 1163.56 419.844 1166.48 414.584C1169.4 409.179 1170.87 402.751 1170.87 395.301ZM1247.28 320.139C1241.88 320.139 1237.35 318.459 1233.7 315.099C1230.19 311.593 1228.44 307.284 1228.44 302.171C1228.44 297.058 1230.19 292.821 1233.7 289.461C1237.35 285.955 1241.88 284.202 1247.28 284.202C1252.69 284.202 1257.14 285.955 1260.65 289.461C1264.3 292.821 1266.13 297.058 1266.13 302.171C1266.13 307.284 1264.3 311.593 1260.65 315.099C1257.14 318.459 1252.69 320.139 1247.28 320.139ZM1262.4 334.602V456H1231.73V334.602H1262.4ZM1348.37 359.802H1327.12V456H1296V359.802H1282.2V334.602H1296V328.466C1296 313.565 1300.24 302.609 1308.71 295.597C1317.18 288.585 1329.97 285.298 1347.06 285.736V311.593C1339.61 311.447 1334.42 312.689 1331.5 315.318C1328.58 317.948 1327.12 322.696 1327.12 329.562V334.602H1348.37V359.802ZM1484.39 334.602L1409.23 513.412H1376.58L1402.88 452.932L1354.23 334.602H1388.63L1419.97 419.405L1451.74 334.602H1484.39Z" fill={logoFill}/>
            <path d="M273.777 445.455L221.041 392.719C213.231 384.908 213.231 372.245 221.041 364.434L323.748 261.728C342.216 243.26 372.158 243.26 390.626 261.728V261.728C409.094 280.196 409.094 310.138 390.626 328.606L273.777 445.455Z" fill="#FF4B4B"/>
            <path d="M220.853 392.919C213.043 385.109 213.043 372.445 220.853 364.635L273.589 311.899L390.438 428.748C408.906 447.216 408.906 477.158 390.438 495.626V495.626C371.97 514.094 342.028 514.094 323.56 495.626L220.853 392.919Z" fill="#56E0FE"/>
            <path d="M273.695 445.608L221.041 392.954C213.231 385.144 213.231 372.48 221.041 364.67L273.71 312.002L340.506 378.798L273.695 445.608Z" fill={logoFill}/>
          </svg>
          </Link>
          </NextLink>
            <Flex display={{ base: 'none', md: 'flex' }} ml={150} align="center">
              <DesktopNav />
              {!sessionId && <NextLink href="/demo" passHref><Button fontWeight="bold" ml={5} px={4} fontSize={['sm', '12']} color={buttonColor} bg={buttonBG} borderRadius={100} _hover={{bg: "gray.200", color: "gray.900"}}><Text fontSize={'md'}></Text>DEMO</Button></NextLink>}
            </Flex>
            </HStack>
          </Flex>
  
          <Stack
            flex={{ base: 1, md: 0 }}
            justify={'flex-end'}
            direction={'row'}
            spacing={[2,6]}
            >
              {sessionId && <NextLink href="/dashboard" passHref><Button  fontWeight="medium" px={4} fontSize={['sm', 'sm']} color={buttonColor} bg={buttonBG} borderRadius={100} _hover={{bg: "gray.200", color: "gray.900"}}><Text fontSize={'md'} mr={1}><BiDna/></Text>Dashboard</Button></NextLink>}
              {sessionId ? authLinks : guestLinks}
          </Stack>
          
        </Flex>
  
        <Collapse in={isOpen} animateOpacity>
          <MobileNav />
        </Collapse>
      </Box>
    );
  }
  
  const DesktopNav = () => {
    const linkColor = useColorModeValue('gray.600', 'gray.200');
    const linkHoverColor = useColorModeValue('gray.800', 'white');
    const popoverContentBgColor = useColorModeValue('white', 'gray.800');
  
    return (
      <Stack direction={'row'} spacing={4}>
        {NAV_ITEMS.map((navItem) => (
          <Box key={navItem.label}>
            <Popover trigger={'hover'} placement={'bottom-start'}>
            <NextLink href={navItem.href ?? '#'} passHref>
                <Link
                  id={navItem.label}
                  p={2}
                  href={navItem.href ?? '#'}
                  fontSize={'14px'}
                  fontWeight="semibold"
                  color={linkColor}
                  _hover={{
                    textDecoration: 'none',
                    color: linkHoverColor,
                  }}>
                  {navItem.label}
                </Link>
                </NextLink>
            </Popover>
          </Box>
        ))}
      </Stack>
    );
  };

  
  const MobileNav = () => {
    return (
      <Stack
        bg={useColorModeValue('white', 'gray.800')}
        p={4}
        display={{ md: 'none' }}
        >
        {NAV_ITEMS.map((navItem) => (
          <MobileNavItem key={navItem.label} {...navItem} />
        ))}
      </Stack>
    );
  };
  
  const MobileNavItem = ({ label, children, href }) => {
    const { isOpen, onToggle } = useDisclosure();
  
    return (
      <Stack spacing={4} onClick={children && onToggle}>
        <Flex
          py={2}
          as={Link}
          href={href ?? '#'}
          justify={'space-between'}
          align={'center'}
          _hover={{
            textDecoration: 'none',
          }}>
          <Text
            fontWeight={600}
            color={useColorModeValue('gray.600', 'gray.200')}>
            {label}
          </Text>
          {children && (
            <Icon
              as={ChevronDownIcon}
              transition={'all .25s ease-in-out'}
              transform={isOpen ? 'rotate(180deg)' : ''}
              w={6}
              h={6}
            />
          )}
        </Flex>
  
        <Collapse in={isOpen} animateOpacity style={{ marginTop: '0!important' }}>
          <Stack
            mt={2}
            pl={4}
            borderLeft={1}
            borderStyle={'solid'}
            borderColor={useColorModeValue('gray.200', 'gray.700')}
            align={'start'}>
            {children &&
              children.map((child) => (
                <Link key={child.label} py={2} href={child.href}>
                  {child.label}
                </Link>
              ))}
          </Stack>
        </Collapse>
      </Stack>
    );
  };

  
  const NAV_ITEMS = [
    {
      label: 'Variants',
      href: '/variants'
    },
    {
      label: 'Genes',
      href: '/genes'
    },
    {
      label: 'Phenotypes',
      href: '/phenotypes'
    },
    {
      label: 'Pricing',
      href: '/pricing'
    },
  ];

